import { Component, OnInit } from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';


@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {
  loadingImage:string= "../../assets/Images/loading-1.gif";
  spinMode = 'indeterminate';
  spinColor = 'primary';
  spinValue = 25;

  constructor() { }

  ngOnInit(): void {
  }

}
